import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { getSystemTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { PermissionService } from 'src/app/shared/permission.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { SystemService } from '../crud-service';
import { SystemCrudIndex } from './crud-index';

@Component({
  selector: 'app-system-index-select',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemService],
})
export class SystemIndexSelectComponent extends SystemCrudIndex {
  override title: string = 'SELECIONE UM SISTEMA';

  override COLUMNS_TO_SHOW_WEB = ['type', 'name'];

  constructor(
    override dialog: MatDialog,
    override service: SystemService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    public dialogRefSelect: MatDialogRef<SystemIndexSelectComponent>,
    private fb: FormBuilder,
    override permissionService: PermissionService,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      params: any;
    },
    override router: Router,
    protected override cdr: ChangeDetectorRef,
    protected override authService: AuthService
  ) {
    super(dialog, service, toastService, mediaObserver, router, cdr, authService, permissionService);
    if (data.params) {
      this.params = data.params;
    }

    this.dataSelect = data;

    setTimeout(() => {
      this.loadList();
    });
  }

  ngOnInit(): void {
    this.displayedColumns = this.COLUMNS_TO_SHOW_WEB;
  }

  override loadList(): void {
    if (this.params) {
      const formParams: any = {};

      if (this.params.type !== undefined && this.params.type !== null && this.params.type > 0) {
        formParams.type = this.params.type;
        console.log('Parâmetro type encontrado:', this.params.type, typeof this.params.type);
      } else if (this.params.type === 0) {
        console.log('Tipo 0 detectado - listando todas as soluções sem filtro de tipo');
      }

      if (this.params.partnerId) {
        formParams.partner = this.params.partnerId;
      }

      formParams.name = '';

      const formGroupFilter = this.fb.group(formParams);
      this.submitAdvancedFilter(formGroupFilter);
    } else {
      super.loadList();
    }
  }

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);

    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe({
        next: (dataWithPagination: any) => {
          let data = dataWithPagination[0];
          this.length = dataWithPagination[1];

          this.dataSource = new MatTableDataSource<any>(
            data.map((item: any) => {
              item['type'] = getSystemTypeDescriptionByValue(item.type);
              return item;
            })
          );
        },
        error: (err) => {
          console.error('Erro na busca:', err);
        }
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.name) {
      params.name = filter.name.trim().toUpperCase();
    }

    // Filtro pelo tipo - só aplicar se for maior que 0
    if (filter.type !== undefined && filter.type !== null && filter.type > 0) {
      const typeValue = Number(filter.type);
      if (!isNaN(typeValue)) {
        params.type = typeValue;
      } else {
        console.warn('Valor de tipo inválido:', filter.type);
      }
    } else if (this.params && this.params.type !== undefined && this.params.type !== null && this.params.type > 0) {
      const typeValue = Number(this.params.type);
      if (!isNaN(typeValue)) {
        params.type = typeValue;
      } else {
        console.warn('Valor de tipo inválido nos params:', this.params.type);
      }
    }

    // Mantém outros parâmetros que possam estar nos params
    if (this.params) {
      if (this.params.partnerId) {
        params.partner_id = this.params.partnerId;
      }
    }

    return params;
  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }

  override filter(event: any): void {
    const formGroupFilter = this.fb.group({
      name: [event],
      type: [this.params.type ? this.params.type : null]
    });

    this.submitAdvancedFilter(formGroupFilter);
  }

  /**
   * Atualiza o tipo de sistema no filtro quando o valor mudar externamente
   * @param systemType Novo tipo de sistema
   */
  public updateSystemType(systemType: string | number): void {
    if (!systemType) return;
    this.params = { ...this.params, type: systemType };

    const formGroupFilter = this.fb.group({
      name: [''],
      type: [systemType]
    });

    this.submitAdvancedFilter(formGroupFilter);
  }
}
